import React from 'react';
import './LeftBlankContent.scss';

const LeftBlankContent = () => {
  return (
    <div className="leftBlankContent col-sm-8 margin-b30">
      <div className="product-images-list">
        <ul className="list">
          <li className="animatedBackground"></li>
          <li className="animatedBackground"></li>
          <li className="animatedBackground"></li>
          <li className="animatedBackground"></li>
          <li className="animatedBackground"></li>
          <li className="animatedBackground"></li>
        </ul>
      </div>
    </div>
  );
};

export default LeftBlankContent;
